import React, {useContext, useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';

import {TableColumn, TableSettings} from "../../../../tableSettings";
import AbstractListView, {
  DataFetchResult,
  ExportRowRenderer,
  ListCustomFilterRenderer,
  ListOrderBy,
  ListRowRenderer
} from "../../../common/AbstractListView";

import periodCloseIcon from '../../../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../../../img/periodclose-12.svg';
import constants from '../../../../constants';
import {Search} from "../../../../filtering";

import {NavigationType, openNewPage} from '../../../../util/navigationHelpers';

import {
  DateRenderer,
  DateTimeRenderer,
  FloatRenderer,
  // NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,
  TextRenderer
} from '../../../../uiControls/SmartTableRenderers';
import UniqueLinkButton from '../../../../uiControls/UniqueLinkButton';
import ApplicationContext from '../../../../ApplicationContext';
import JobListViewContext, { RightClickContext } from '../../../common/JobListViewContext';
import useGlobalOkDialog from '../../../../hooks/useGlobalOkDialog';
import { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../../ui/ActionButton';
import useFunctionKeys from '../../../../hooks/useFunctionKeys';
import {JobNames} from "../../../../framework.core/JobNames";
import {payroll2List} from "../../tableSettings";
import ListViewShortcutMenu from '../../../common/ListViewShortcutMenu';
import { Payroll2ListItem } from '../../../../fms.data/models/Payroll2ListItem';
import * as XCol from '../../../../framework.core/XExportColumn';
import ToolboxMenuItem from '../../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../../ui/menu/Menu';
import JobListSuntekCommand from '../../../common/JobListSuntekCommand';
import CheckBoxUncontrolled from '../../../../ui/CheckBoxUncontrolled';
import Label from '../../../../ui/Label';
import { FmsSecTask } from '../../../../fms.core/constants';
import { SuntekSettings, SystemSettings } from '../../../../ifmsTypes';
import { findSecurityTaskWithBranch, getSecBySecTask } from '../../../../util';
import { useJournal } from '../journal/JournalListView';
import useGlobalYesNoDialog from '../../../../hooks/useGlobalYesNoDialog';
import { StatusNotUseFileLockedRenderer } from '../../../common/commonListRenderers';
import CheckBoxIcon from '../../../../ui/CheckBoxIcon';
import { nullableCheckBoxValue } from '../../../common/commonExportFormat';
import InfoAreaDrawer from '../../../../uiControls/infoArea/InfoAreaDrawer';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DeleteIconButton, DeleteIconButton2, EditIconButton, EditIconButton2, JournalIconButton, ViewIconButton, ViewIconButton2 } from '../../../../ui/IconButton';
import { SecType } from '../../../../fms.enum';

function IndicatorRenderer({ data, row}:any) {
  const l = data[row.index];
  let dataTooltip = '';
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="12px" src={periodCloseIcon2} id={'redIcon'} style={{ position: 'relative', top: '0px', marginTop: '4px' }} alt="" />;

  return (
    <div className="ifms-table-default" id={`ifms-table-default-${row.index}`} data-tooltip={dataTooltip} style={{ width: '100%', minHeight: '22px' }}>{content}</div>
  );
}

function PaidFilterRenderer({value, onChange}: any) {
  return (
    <div>
      <CheckBoxUncontrolled name='ifms-filter-bool-search-check' initialValue={value} onChange={e => onChange(e)} />
      <Label style={{marginLeft: '5px'}} label="Paid" />
    </div>
  );
}

function CheckboxIconRenderer({data, row, cell}: any) {
  const l = data[row.index];

  if (cell && cell.value) {
    return (
      <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip="Paid">
        <CheckBoxIcon value={true} />
      </div>);  
  } else {
    let amount = 0;
    switch(cell.column.dataIndex) {
      case "netPayPaid":
        amount = l.netPayAmt;
        break;
      case "fedTaxPaid":
        amount = l.fedTaxAmt;
        break;
      case "fedUnemployPaid":
        amount = l.fedUnemployAmt;
        break;
      case "stateTaxPaid":
        amount = l.stateTaxAmt;
        break;
      case "stateUnemployPaid":
        amount = l.stateUnemployAmt;
        break;
    }

    if (amount === 0) {
      return (
        <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default">x</div>
      );
    } else {
      return (
        <div id={`${cell.column.id}-${row.index}`} className="ifms-table-default" data-tooltip="Not Paid">
          <CheckBoxIcon value={true} color="red" />
        </div>
      ); 
    }
  }
}

function useSelectedOperations() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);
  const history = useHistory();
  const operation = 'accounting';

  const selectedElement = jobListContext.selectedElement as Payroll2ListItem;
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function create() {
    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPayroll2/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    openNewPage(history, `/${operation}/acPayroll2/add`, NavigationType.newPage);
  }

  async function deleteEntity() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPayroll2/edit/${selectedElement.id}`) || 
      jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPayroll2/view/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Payroll first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Do you want to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Payroll2, {
        id: selectedElement.id,
        pimsLinkId: 0
      });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message, false,null,'warning');
      }
    }
    // if (selectedElement.void || selectedElement.fedTaxPaid || selectedElement.stateTaxPaid || selectedElement.netPayPaid || selectedElement.fedUnemployPaid || selectedElement.stateUnemployPaid) {
    //   return;
    // }
    // const id = selectedElement.id;
    // openNewPage(history, `/${operation}/acPayroll2/delete/${id}`, NavigationType.newPage);
  }

  async function edit() {
    if (!selectedElement) {
      return;
    }
    // if (selectedElement.void || selectedElement.fedTaxPaid || selectedElement.stateTaxPaid || selectedElement.netPayPaid || selectedElement.fedUnemployPaid || selectedElement.stateUnemployPaid) {
    //   return;
    // }
    if (selectedElement.void || selectedElement.allPaid) {
      return;
    }
    const id = selectedElement.id;
    const editUrl = `/${operation}/acPayroll2/edit/${id}`;
    const viewUrl = `/${operation}/acPayroll2/view/${id}`;

    // if (jobListContext.hasOpenedScreenStartingWithUrlWithoutMe(`/${operation}/acPayroll2/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/${operation}/acPayroll2/edit/${id}`;
    const viewUrl = `/${operation}/acPayroll2/view/${id}`;
    const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctPayroll, selectedElement.branch);
    const urls = [viewUrl];
    if(listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function copy() {
    if (!selectedElement) {
      return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPayroll2/add`)) {
      await showGlobalOkDialog(<p>New operation is already in progress</p>);
      return;
    }

    const id = selectedElement.id;
    openNewPage(history, `/${operation}/acPayroll2/add?copyId=${id}`, NavigationType.newPage);
  }

  return {create, deleteEntity, edit, view, copy, operation};
}

function RightClickMenu({dismiss}:{dismiss: VoidFunction}) {
  const { create, deleteEntity, edit, view } = useSelectedOperations();
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as Payroll2ListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctPayroll, selectedElement?.branch);

  const items = [
    { label: 'New', shortcut: 'F2', separator: false, hidden: !listSec?.grantAdd },
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) =>({
    label: <ToolboxMenuItem name="payroll-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item:IfmsMenuItem) {
    switch (item.index) {
      case 0:
        create();
        break;
      case 1:
        view();
        break;
      case 2:
        edit();
        break;
      case 3:
        deleteEntity();
        break;
      case 4:
        jobListContext.triggerTableSearch('F5');
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');
        break;
      case 6:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function ListCommands() {
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  const selectedElement = jobListContext.selectedElement as Payroll2ListItem;

  const {edit, view, deleteEntity, operation} = useSelectedOperations();

  function hasOpenedViewOrEditFor(id: number) {
    return jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPayroll2/edit/${id}`) || jobListContext.hasOpenedScreenStartingWithUrl(`/${operation}/acPayroll2/view/${id}`);
  }
  
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctPayroll,selectedElement?.branch);

  const hasSelectedRow = !!selectedElement;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
  const canBeAdd = listSec?.grantAdd;
  const canBeEdit = hasSelectedRow && listSec?.grantEdit && !selectedElement.void && !selectedElement.allPaid
  // &&((selectedElement.netPayPaid ?? 0) + (selectedElement.fedTaxPaid ?? 0) + (selectedElement.fedUnemployPaid ?? 0) + (selectedElement.stateTaxPaid ?? 0) + (selectedElement.stateUnemployPaid ?? 0) <= 0)
   ;

  return (
     <div className='ifms-common-no-vertical-separator-gap-margin'>
      {/* {appContext.suntekSettings?.company?.billingsTabVersion === 2 ?  <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}/> : <></>} */}
      <div className='ifms-common-vertical-gap-8'>
        <UniqueLinkButton newStyle name='payroll-list-add-button' display="primary" link={`/${operation}/acPayroll2/add`} disabled={!canBeAdd} label={''} useOnlyIcon data-tooltip='New' iconMode />
        <EditIconButton2 name='payroll-list-edit-button' disabled={!canBeEdit} onClick={edit} useText/>
        <ViewIconButton2 name='payroll-list-view-button' disabled={!hasSelectedRow} onClick={view} useText />
        <DeleteIconButton2 name='payroll-list-delete-button' disabled={!canBeDeleted} onClick={deleteEntity} useText/>
      </div>
    </div>
  );
}

function ListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function ListViewExtras() {
  useFunctionKeys({onFunction: onFunctionKey});

  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as Payroll2ListItem;
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTaskWithBranch(appContext, FmsSecTask.AcctPayroll, selectedElement?.branch);

  const {create, edit, view} = useSelectedOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
      if (!unprocessedFkey) {
        return;
      }

      doProcessFkey();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {

    } else if (unprocessedFkey === "F2") {
      if(listSec?.grantAdd)
        create();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F2', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }


  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.Payroll2}
      jobId={(jobListContext.selectedElement as Payroll2ListItem | null)?.id ?? 0}
      onClose={() => jobListContext.setInfoAreaContent('none')}
    />
  );
}

function formatData(data:Array<Payroll2ListItem>) {
  return data.map(d => ({
    ...d,
  }));
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as Payroll2ListItem;
  const {switchJournal} = useJournal();
  const appContext = useContext(ApplicationContext);
  
  if (!getSecBySecTask(appContext, FmsSecTask.ListJournalBillings, SecType.Read) && !userId.startsWith('@')) {
    return null;
  }

  return (
    <JournalIconButton onClick={() => switchJournal(JobNames.Payroll2, selectedElement.id)} useText/>
  );
}

/**
 * Concrete implementation for Payroll Summary List screen
 *
 * @class Payroll2ListView
 * @extends {AbstractListView}
 */
class Payroll2ListView extends AbstractListView {
  async fetchAndFormatData(api: any, search: Search, pageNum: number, limit: number): Promise<DataFetchResult> {
    const apiResult = await api.getListItems(
      JobNames.Payroll2,
      'Payroll2ListItem',
      Payroll2ListItem.calculateSearchParameters(search,Payroll2ListItem.MapSearchFields),
      pageNum,
      limit,
      search.pageSize,
      search.pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return {data: [], totalCount: 0};
    }

    return {data: formatData(apiResult.entities), totalCount: apiResult.totalCount};
  }


  async exportFormatDataWithExcel(api: any, search: Search, pageNum: number, limit: number, pageSize: number, pagePerBatch: number): Promise<Array<any>> {
    const apiResult = await api.getListItems(JobNames.Payroll2, 'Payroll2ListItem',
      Payroll2ListItem.calculateSearchParameters(search,Payroll2ListItem.MapSearchFields),
      pageNum,
      limit,
      pageSize,
      pagePerBatch,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return [];
    }

    return  formatData(apiResult.entities);
  }

  getCustomFilterRenderers(): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v:any|null|undefined) => v,
      },
      {
        accessor: 'netPayPaid',
        renderer: PaidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v.value ?? v,
      },
      {
        accessor: 'fedTaxPaid',
        renderer: PaidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v.value ?? v,
      },
      {
        accessor: 'fedUnemployPaid',
        renderer: PaidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v.value ?? v,
      },
      {
        accessor: 'stateTaxPaid',
        renderer: PaidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v.value ?? v,
      },
      {
        accessor: 'stateUnemployPaid',
        renderer: PaidFilterRenderer,
        searchValueExtractor: (v:any|null|undefined) => v.value ?? v,
      },
    ];
  }

  getInfoAreaEntityId() {
    return constants.infoAreaEntity.oceanImportMbl;  // ??
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    return Payroll2ListItem.getExportCollection(useBranch).map(x => {
      const colRenderer:ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if(x.dataIndex === 'status') colRenderer.Cell = IndicatorRenderer;
      else if(x.dataIndex === 'netPayPaid') colRenderer.Cell = CheckboxIconRenderer;
      else if(x.dataIndex === 'fedTaxPaid') colRenderer.Cell = CheckboxIconRenderer;
      else if(x.dataIndex === 'fedUnemployPaid') colRenderer.Cell = CheckboxIconRenderer;
      else if(x.dataIndex === 'stateTaxPaid') colRenderer.Cell = CheckboxIconRenderer;
      else if(x.dataIndex === 'stateUnemployPaid') colRenderer.Cell = CheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Double) colRenderer.Cell = (props:any) => <FloatRenderer {...props} decimals={2} />;
      else if(x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = CheckboxIconRenderer;
      else if(x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if(x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      else if(x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({accessor: 'status', changedValue: (value: any)=> { return value['status'] === 'PC' ? 'Period Close' : ''}});
    colRenderer.push({ accessor: 'netPayPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['netPayPaid'])} });
    colRenderer.push({ accessor: 'fedTaxPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['fedTaxPaid'])} });
    colRenderer.push({ accessor: 'fedUnemployPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['fedUnemployPaid'])} });
    colRenderer.push({ accessor: 'stateTaxPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['stateTaxPaid'])} });
    colRenderer.push({ accessor: 'stateUnemployPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['stateUnemployPaid'])} });
    colRenderer.push({ accessor: 'netSalaryPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['netSalaryPaid'])} });
    colRenderer.push({ accessor: 'addPayPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['addPayPaid'])} });
    colRenderer.push({ accessor: 'addTaxPaid', changedValue: (value: any) => { return nullableCheckBoxValue(value['addTaxPaid'])} });
    return colRenderer;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'id',
      orderByAscending: false,
    };
  }

  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const tsettings =  payroll2List;
    const useBranch = systemSettings?.enableBranch ?? false;
    const cols = Payroll2ListItem.getExportCollection(useBranch);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type};
    });
    return tsettings;
  }

  renderCommands() {
    return (
      <ListCommands/>
    );
  }

  renderBeforeConfigureButton() {
    return (
      <ListToolbar/>
    );
  }

  renderExtras() {
    return <ListViewExtras/>
  }

  getViewUrlFor(row: Payroll2ListItem) {
    return row && row.id ? `/accounting/acPayroll2/view/${row.id}` : '';
  }

  getListViewTitle() {
    return 'Payroll Summary List';
  };

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.Payroll2} keyProp='id' showAdjustBalance={false} />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }

  // hasMemo(): boolean {
  //   return false;
  // }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default Payroll2ListView;
